function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M20.87,63.2l-6.14-43.96c0-.95.21-1.91.64-2.86l-3.28.74c-2.12.42-3.5,2.54-3.07,4.66l8.69,40.99c.42,1.8,2.01,3.07,3.81,3.07.32,0,.53,0,.85-.11l.42-.11c-.95-.53-1.59-1.38-1.91-2.44Z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M67.15,14.16h-28.81c-2.12,0-3.92,1.8-3.92,3.92v41.95c0,2.12,1.8,3.92,3.92,3.92h28.81c2.12,0,3.92-1.8,3.92-3.92V18.18c0-2.22-1.8-4.03-3.92-4.03ZM61.86,44.24c-.64,1.27-1.91,2.22-3.28,2.54-1.48.32-3.07.11-4.34-.74-.11,0-.11-.11-.21-.11v1.65h1.8v2.65h-6.25v-2.65h1.8v-1.65c-.11,0-.11.11-.21.11-.85.53-1.91.85-2.97.85-.42,0-.95-.11-1.38-.21-1.38-.32-2.54-1.27-3.28-2.54-2.65-5.08,1.8-8.9,4.98-11.65,1.17-.85,2.22-1.91,3.18-3.07l1.06-1.59,1.06,1.59c.95,1.17,2.01,2.22,3.18,3.18,3.28,2.75,7.63,6.46,4.87,11.65Z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M31.99,17.23c0-1.06.32-1.91.95-2.75l-3.5.21c-2.12.11-3.81,2.01-3.6,4.24l2.97,41.84c.11,2.01,1.8,3.6,3.92,3.71h.85c-.64-.74-1.17-1.69-1.38-2.75l-.21-44.49Z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M23.09,17.76c.11-.95.53-1.91,1.06-2.75l-3.71.53c-2.12.32-3.6,2.33-3.39,4.45l5.83,41.52c.32,1.91,1.91,3.39,3.92,3.39h.74c-.53-.95-1.06-1.91-1.27-2.86l-3.18-44.28Z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 80 80"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
};

export default __webpack_public_path__ + "static/media/TableGames-active.8ce35827.svg";
export { SvgComponent as ReactComponent };